function Header() {
  return (
    <div style={headerStyle}>
      <div style={logoContainer}>
        <div style={logoTop}>🛹 SKATE</div>
        <div style={logoBottom}>ATLAS🗺️🔍</div>
      </div>
    </div>
  );
}

/* ---------- styles ---------- */

const headerStyle = {
  position: "fixed",
  top: "40px",
  left: "20px",
  padding: "10px 10px",
  background: "rgba(0,0,0,0.55)",
  backdropFilter: "blur(10px)",
  borderRadius: "14px",
  zIndex: 1000,
};

const logoContainer = {
  fontFamily: "Frijole, cursive",
  textTransform: "uppercase",
  lineHeight: "1",
  color: "white",
  textShadow: `
    -2px -2px 0 #000,
     2px -2px 0 #000,
    -2px  2px 0 #000,
     2px  2px 0 #000,
     0 6px 12px rgba(0,0,0,0.6)
  `,
};

const logoTop = {
  fontSize: "20px",
};

const logoBottom = {
  fontSize: "32px",
  marginTop: "-4px",
  color: "#ff453a",
};

export default Header;